import { get, includes, isEmpty, map } from 'lodash';

function getCurrentStepsStatistics(projects, transitionsDat, transitionsJson) {
  const steps = {};

  if (isEmpty(transitionsDat) || isEmpty(transitionsJson)) {
    return steps;
  }

  const STATUS_WEIGHT = {
    'In_Process': 0,
    'Completed': 1,
    'Reviewed': 2,
    'Locked': 3,
  };

  for (let i = 0; i < transitionsDat.length; i += 1) {
    const [project, , , status, step] = transitionsDat[i];

    if (!includes(projects, transitionsJson.projects[project])) {
      // eslint-disable-next-line no-continue
      continue;
    }

    const projectNum = get(steps[step], 'project');
    const lastStatusNum = get(steps[step], 'lastStatus');

    if (!(projectNum && lastStatusNum)) {
      steps[step] = {
        project,
        lastStatus: status,
      };
    }

    const lastStatus = transitionsJson.states[lastStatusNum];
    const currentStatus = transitionsJson.states[status];

    if (STATUS_WEIGHT[currentStatus] > STATUS_WEIGHT[lastStatus]) {
      // eslint-disable-next-line prefer-destructuring
      steps[step].lastStatus = status;
    }
  }
  const statistics = {};
  // eslint-disable-next-line no-unused-vars
  map(steps, (value, key) => {
    const project = transitionsJson.projects[value.project].toLowerCase();
    const lastStatus = transitionsJson.states[value.lastStatus].toLowerCase();

    const hasProject = get(statistics, project);

    if (!hasProject) {
      statistics[project] = {
        in_process: 0,
        completed: 0,
        reviewed: 0,
        locked: 0,
        all: 0,
        progress: 0,
      }
    }

    statistics[project][lastStatus] += 1;
    statistics[project].all += 1;

    if (statistics[project].all) {
      statistics[project].progress = parseFloat((((0.5 * statistics[project].completed + statistics[project].reviewed) / statistics[project].all) * 100).toFixed(1));
    }
  });

  return statistics;
}

export default getCurrentStepsStatistics;
